import React from "react";
import "./Navbar.css";
import { AiOutlineMenu } from "react-icons/ai";
import { ImCross } from "react-icons/im";
import { useState } from "react";

export default function Navbar() {
  const [display, setDisplay] = useState("none");

  const handleopen = () => {
    setDisplay("block");
  };
  const handleclose = () => {
    setDisplay("none");
  };

  return (
    <div className="navmain">
      <div className="nav1">
        <p className="head">Personal</p>
      </div>

      <div className="nav2">
        <p> Home </p>
        <p> About Me </p>
        <p> Experience </p>
        <p> Projects </p>
        <p className="Con"> Contact Me </p>
      </div>

      <div className="respnav">
        <AiOutlineMenu onClick={handleopen} color="#9cb4ff" size={20} />
      </div>
      <div style={{ display: display }} className="respfullnav">
        <ImCross
          onClick={handleclose}
          color="white"
          style={{ marginTop: "10px", marginLeft: "90%", cursor: "pointer" }}
        />
        <p> Home </p>
        <p> About Me </p>
        <p> Experience </p>
        <p> Projects </p>
        <p> Contact Me </p>
      </div>
    </div>
  );
}
